import { toPX } from '../utils';

function buildLockedVideo(element) {
  var $element = $(element),
    blankElement = '<div></div>',
    $videoThumbnailPlaceholder = $('img', $element);

  var videoOverlayOptions = {
      class: 'video-overlay',
      css: {
        'min-height': toPX($videoThumbnailPlaceholder.height()),
      },
    },
    videoLockTextOptions = {
      class: 'ti-locked-video-text mt1 serif',
    },
    videoLockIconOptions = {
      class: 'ti-locked-video-icon fa fa-lock',
    },
    videoLockSubscribeButtonOptions = {
      class: 'button button-mini mt2 button-magenta js-subscribe-button',
    },
    videoLockLoginButtonOptions = {
      class: 'button button-ghost button-mini mt2 ml2',
    };

  var $videoOverlay = $(
      blankElement,
      (videoOverlayOptions = {
        class: 'video-overlay',
        css: {
          'min-height': toPX($videoThumbnailPlaceholder.height()),
        },
      })
    ),
    $videoLockText = $(blankElement, videoLockTextOptions),
    $videoLockIcon = $('<i></i>', videoLockIconOptions),
    $videoLockCTAButtonContainer = $(blankElement, {}),
    $videoLockSubscribeButton = $('<a></a>', videoLockSubscribeButtonOptions),
    $videoLockLoginButton = $('<a></a>', videoLockLoginButtonOptions);

  // Add the locked icon
  $videoOverlay.append($videoLockIcon);

  // Add the locked message
  $videoLockText.text(
    'This video requires a subscription to view. Please subscribe or sign in to continue.'
  );
  $videoOverlay.append($videoLockText);

  // Add the locked cta
  $videoLockSubscribeButton.text('Subscribe');
  // Remove the leading slash since rails redirects relative to the root
  $videoLockSubscribeButton.attr('href', '/subscribe?redirect_to=' + window.location.pathname);
  $videoLockCTAButtonContainer.append($videoLockSubscribeButton);
  $videoLockLoginButton.text('Sign in');
  $videoLockLoginButton.attr('href', '/sessions/new');
  $videoLockCTAButtonContainer.append($videoLockLoginButton);
  $videoOverlay.append($videoLockCTAButtonContainer);

  $element.append($videoOverlay);
}

export { buildLockedVideo };
